import React from "react";
import styled from "styled-components";

import { TestmonialsData } from "./TestmonialsData";

const buttonText = ["<", ">"];

const Testmonials = () => {
  const scroll = (direction) => {
    const el = document.getElementById("e1");
    const tg = document.getElementById("tg");
    tg.scrollLeft = tg.scrollLeft + el.offsetWidth * direction;
  };
  return (
    <TestmonialsWrapper id="testmonials">
      <TestmonialsSentence>Culpa perferendis excepturi.</TestmonialsSentence>
      <TestmonialsTitle>Testmonials</TestmonialsTitle>
      <TGWrapper id="tg">
        {TestmonialsData.PersonsData.map((item) => (
          <TestmonialsGrid id={item.id}>
            <TestmonialsImage imageSource={item.imageSource} />
            <TestmonialsContent>
              <TCNumber align="left">66</TCNumber>
              <TCText>{TestmonialsData.text}</TCText>
              <TCNumber align="right">66</TCNumber>
              <TCName>{item.name}</TCName>
              <TCName2>{item.proffecy}</TCName2>
            </TestmonialsContent>
          </TestmonialsGrid>
        ))}
      </TGWrapper>
      <TCButtonWrapper>
        <TCButton onClick={() => scroll(-1)}>{buttonText[0]}</TCButton>
        <TCButton onClick={() => scroll(1)}>{buttonText[1]}</TCButton>
      </TCButtonWrapper>
    </TestmonialsWrapper>
  );
};

const TestmonialsWrapper = styled.div`
  width: 100vw;
  height: 57.5vh;
  background-color: #e1f1f5;
  overflow-y: hidden;

  @media screen and (orientation: portrait) {
    height: 65vh;
  }
`;

const TGWrapper = styled.div`
  width: 70vw;
  margin-left: 15vw;
  height: 65vh;
  overflow-x: scroll;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  scroll-behavior: smooth;

  @media screen and (orientation: portrait) {
    width: 95vw;
    margin-left: 2.5vw;
  }
`;

const TestmonialsSentence = styled.h1`
  margin: 0;
  color: gray;
  font-size: 0.9vw;
  font-weight: 400;
  margin-left: 15vw;
  padding-top: 2vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 1.75vh;
    margin-left: 10vw;
  }
`;
const TestmonialsTitle = styled.h1`
  margin: 0;
  font-size: 2vw;
  color: black;
  font-weight: 500;
  margin-left: 15vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 4.25vh;
    margin-left: 10vw;
  }
`;

const TestmonialsGrid = styled.div`
  width: 70vw;
  height: 28vh;
  margin-top: 1vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);
  justify-items: center;
  align-items: center;

  @media screen and (orientation: portrait) {
    width: 95vw;
    height: 46vh;
    overflow: hidden;
    transform: translateY(-2.5vh);
  }
`;

const TestmonialsImage = styled.div`
  width: 10vw;
  height: 10vw;
  border-radius: 50%;
  background-color: aliceblue;
  transform: translateY(1vh);
  background-size: cover;
  background-image: url(${({ imageSource }) => imageSource});

  @media screen and (orientation: portrait) {
    width: 15vh;
    height: 15vh;
    transform: translateY(1vh) translateX(-3vw);
    overflow: hidden;
  }
`;

const TestmonialsContent = styled.div`
  width: 55vw;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (orientation: portrait) {
    transform: translateY(5vh);
    overflow: hidden;
  }
`;

const TCNumber = styled.h3`
  font-weight: 500;
  font-size: 1.15vw;
  color: #333333;
  width: 55vw;
  max-width: 55vw;
  margin: 0;
  text-align: ${({ align }) => align};

  @media screen and (orientation: portrait) {
    font-size: 1.6vh;
    max-width: 50vw;
  }
`;

const TCText = styled.h2`
  font-size: 1.15vw;
  font-weight: 300;
  color: grey;
  width: 55vw;
  max-width: 55vw;
  text-align: left;

  @media screen and (orientation: portrait) {
    font-size: 1.5vh;
    max-width: 50vw;
  }
`;

const TCName = styled.h1`
  font-size: 1.05vw;
  font-weight: 500;
  color: black;
  text-align: left;
  margin: 0;
  width: auto;

  position: relative;

  ::before {
    display: block;
    position: absolute;
    content: "";
    width: 7.6%;
    height: 0.2vw;
    background-color: #f53b4d;
    transform: translateY(-0.1vh);
  }

  @media screen and (orientation: portrait) {
    font-size: 1.9vh;

    ::before {
      width: 26%;
      height: 0.25vh;
      transform: translateY(0vh);
    }
  }
`;

const TCName2 = styled.h2`
  font-size: 0.75vw;
  font-weight: 500;
  color: grey;
  text-align: left;
  margin: 0;

  @media screen and (orientation: portrait) {
    font-size: 1.5vh;
  }
`;

const TCButtonWrapper = styled.div`
  width: 7vw;
  height: 4vw;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-left: 47vw;
  margin-top: 1vw;

  justify-items: center;
  align-items: center;

  transform: translateY(-32vh);

  @media screen and (orientation: portrait) {
    width: 30vw;
    height: 7vh;
    margin-left: 35vw;
    transform: translateY(-22vh);
  }
`;

const TCButton = styled.button`
  cursor: pointer;
  width: 3vw;
  height: 3vw;

  border: none;
  font-size: 1.3vw;
  color: black;
  background-color: transparent;
  font-weight: 500;
  color: #333333;

  transition: transform 300ms;
  will-change: transform;

  :hover {
    transform: scale(1.25);
  }

  @media screen and (orientation: portrait) {
    width: 5vh;
    height: 5vh;
    font-size: 2.5vh;
  }
`;

export default Testmonials;
